import * as types from '../constants'
import callAPI from '../callAPI/callAPI'

// Get all
export const getAllBlog = (blogs) => {
    return {
        type: types.GET_ALL_BLOG,
        payload: blogs
    }
}

export const fetchAPIAllBlog = () => {
    return dispatch => {
        return callAPI('blogs', 'GET', null).then(res => {
            dispatch(getAllBlog(res.data))
        }) 
    }
}

// Get item
export const getBlogItem = (blog) => {
    return {
        type: types.GET_BLOG_DETAIL,
        payload: blog
    }
}

export const fetchAPIBlogItem = (id) => {
    return dispatch => {
        return callAPI(`blogs/${id}`, 'GET', null).then(res => {
            dispatch(getBlogItem(res.data))
        }) 
    }
}

// add blog

export const addBlog = (blog) => {
    return {
        type: types.ADD_BLOG,
        payload: blog
    }
}

export const fetchAPIAddBlog = (blog) => {
    return dispatch => {
        return callAPI('blogs', 'POST', blog).then(res => {
            dispatch(addBlog(res.data))
            dispatch(fetchAPIAllBlog())
        })
    }
}

// Edit blog

export const editBlog = (blog) => {
    return {
        type: types.EDIT_BLOG,
        payload: blog
    }
}

export const fetchAPIEditBlog = (blog) => {
    return dispatch => {
        return callAPI(`blogs/${blog.id}`, 'PUT', blog).then(res => {
            dispatch(editBlog(res.data));
            dispatch(fetchAPIAllBlog());
            dispatch(fetchAPIBlogItem(blog.id))
        })
    }
}

// delete blog

export const deleteBlog = (id) => {
    return {
        type: types.DELETE_BLOG,
        payload: id
    }
}

export const fetchAPIDeleteBlog = (id) => {
    return dispatch => {
        return callAPI(`blogs/${id}`, 'DELETE', null).then(res => {
            dispatch(deleteBlog(id));
            dispatch(fetchAPIAllBlog())
        })
    }
}